import React from "react";
import QRCode from "react-qr-code";

type QRFooterProps = {
    blockchainUid: string;
    refDate?: string;
    mfcUserName?: string;
    mfcInfoName?: string;
}
export const QRFooter: React.FC<QRFooterProps> = ({
                                                      mfcInfoName,
                                                      mfcUserName,
                                                      blockchainUid,
                                                      refDate
                                                  }) => {

    const url = `https://www.mos.ru${process.env.PUBLIC_URL}`;

    return (
            <div className="qr_code--container">

                {refDate &&
                        <p className="doc-title__subtitle">
                            Документ действителен на <b>{refDate}</b>
                        </p>
                }
                <div className="doc-row doc-row--m2_3">
                    <div className="doc-row__title doc-row__title--qr">
                        <QRCode value={url} size={100}/>
                    </div>
                    <div className="doc-row__value">
                        <p>Проверьте подлинность документа жилищного учета. Для этого:</p>
                        <ol>
                            <li>
                                Перейдите по ссылке <a href={url}>{url}</a> или используйте QR-код.
                            </li>
                            <li>
                                Введите идентификатор документа в поле поиска, номер этого документа: №{' '}
                                {blockchainUid}
                            </li>
                            <li>
                                Получите справку о наличии/отсутствии задолженности/переплаты в электронном виде.
                            </li>
                        </ol>
                    </div>
                </div>
                {
                        mfcInfoName && mfcUserName &&
                        <div className="doc-row doc-title__subtitle doc-mfc-line doc-row--m2_3">
                            <p>М.П. {mfcInfoName}</p>
                            <p>/ {mfcUserName} /__________________/</p>
                        </div>
                }
                <p className="doc-row__value--qr font-semibold">
                    Часть информации, обозначенная символами «***», скрыта из документа в соответствии с федеральным
                    законом от 27.07.2006 № 152-ФЗ «О персональных данных».
                    Для формирования документа с полной информацией необходимо предоставить согласие на предоставление
                    персональных данных всех граждан.
                </p>

                <p className="doc-row__value--qr ">
                    Документ сформирован с использованием информационной системы «Автоматизированная система управления
                    «Информационное обеспечение деятельности ЕИРЦ»» (АСУ ЕИРЦ)
                </p>

            </div>
    );
}
